import React from "react";
import SkillList from "./SkillList";
import './styles/skills.css'
import { LANGUAGES, FRAMEWORKS, TOOLS } from '../constants.js'

export default function Skills() {
  return (
    <section id="skills" className="section">
      <h1>Skills {"{"}</h1>

      <div className="skills-container">
        <SkillList title="Languages" skills={LANGUAGES} />
        <hr />
        <SkillList title="Frameworks" skills={FRAMEWORKS} />
        <hr />
        <SkillList title="Tools and Technologies" skills={TOOLS} />
      </div>

      <h1>{"}"}</h1>
    </section>
  );
}
